import {
  DefaultCarPageComponentProps,
  ColorInfo,
} from "@/app/interface/components";
import CarRotation from "./CarRotation";
import { useEffect } from "react";
import { useImageCache } from "@/app/hooks/useImageCache";

function CarOverview({
  car,
  model,
  version,
  color,
  setModel,
  setVersion,
  setColor,
}: DefaultCarPageComponentProps) {
  const { image, isLoading } = useImageCache(color?.carrossel || "");

  useEffect(() => {}, [color, model, version]);

  return (
    <section className="flex flex-col w-full max-w-[500px] pt-24 md:pt-0  items-center justify-center">
      <div className="flex flex-col items-center pb-6 w-full max-w-[655px] max-md:max-w-full">
        <h2 className="flex gap-4 justify-center items-center px-14 pt-8 w-full text-3xl leading-tight text-zinc-900 max-md:px-5">
          Conheça as versões
        </h2>

        {/* Seletor de modelos mobile */}
        <div className="lg:hidden flex mx-auto mt-4 overflow-hidden justify-center self-stretch my-auto text-xs leading-snug whitespace-nowrap bg-white border border-solid border-zinc-500 rounded-[50px] text-zinc-500 lg:w-full w-11/12 max-w-[331px]">
          {car?.models.map((m, index) => (
            <div
              key={m.name + index}
              className={`flex flex-1 cursor-pointer gap-4 justify-center items-center text-black px-2 py-2 h-full border-r border-l border-zinc-500 ${
                model?.name === m.name && "bg-neutral-500 text-white"
              }`}
              onClick={() => {
                setModel?.(m);
                setVersion?.(m.versions[0]);
                setColor?.(m.versions[0].colors[0]);
              }}
            >
              <div className="flex gap-1 items-center">
                <p>{m.name}</p>
              </div>
            </div>
          ))}
        </div>

        {/* Conteúdo principal */}
        <div className="flex flex-col px-4 py-6 max-w-full items-center w-full">
          {/* Seletor de versões */}
          <div className="flex flex-wrap max-w-96 w-full items-start mxc text-sm leading-snug text-center whitespace-nowrap text-neutral-400">
            {model?.versions?.map((v, index) => (
              <div
                key={v.name + index}
                className={`px-6 py-4 flex-1 border-b-2 cursor-pointer min-h-[40px] max-md:px-5 ${
                  v.name === version?.name
                    ? "text-neutral-700 border-neutral-700"
                    : "text-zinc-300 border-zinc-300"
                }`}
                onClick={() => {
                  setVersion?.(v);
                  setColor?.(v.colors[0]);
                }}
              >
                {v.name}
              </div>
            ))}
          </div>

          {/* Visualizador 360° */}
          <div className="max-w-[400px] w-full">
            {color?.carrossel && !isLoading && (
              <CarRotation spriteUrl={color.carrossel} totalFrames={36} />
            )}
            {isLoading && (
              <div className="w-full h-64 flex items-center justify-center">
                <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-red-600" />
              </div>
            )}
          </div>

          {/* Seletor de cores */}
          <div className="flex w-full items-center justify-center gap-4 mt-2">
            {version?.colors.map((c, i) => (
              <div
                key={c.name + i}
                className={`w-6 h-6 rounded-full shadow shadow-black ${
                  c.name === color?.name && "scale-125"
                } cursor-pointer`}
                onClick={() => setColor?.(c)}
                style={{
                  backgroundColor: c.hex,
                }}
              />
            ))}
          </div>

          {/* Nome da cor */}
          <div className="flex gap-1.5 max-w-60 w-full justify-center items-center mt-2 text-sm text-neutral-700">
            <div className="flex-1 w-full h-[2px] bg-gradient-to-r from-neutral-100 to-neutral-400" />
            <span>{color?.name}</span>
            <div className="flex-1 w-full h-[2px] bg-gradient-to-l from-neutral-100 to-neutral-400" />
          </div>
        </div>
      </div>
    </section>
  );
}

export default CarOverview;
